import React, { memo } from 'react';
import { CheckCircleIcon, XCircleIcon } from 'lucide-react';
const forYou = ['Eres adulto y quieres un método simple y práctico.', 'Estás cansado de memorizar reglas.', 'Quieres material "listo para usar" y avanzar rápido.', 'Te sirve estudiar 10–15 minutos por día.'];
const notForYou = ['Quieres un curso con clases en vivo 1 a 1.', 'Buscas gramática académica profunda (estilo universidad).', 'No vas a practicar nada (ni 10 minutos).'];
export function ForWhomSection() {
  return <section className="w-full bg-[#F8F9FA] py-8 md:py-14 px-4" data-id="element-53">
      <div className="max-w-3xl mx-auto" data-id="element-54">
        <div className="grid md:grid-cols-2 gap-6" data-id="element-55">
          <div className="bg-white p-5 rounded-xl border-t-4 border-[#22C55E]" data-id="element-56">
            <h3 className="text-xl font-bold text-[#1A1A2E] mb-4 text-center" data-id="element-57">
              ESTO ES PARA TI SI:
            </h3>
            <ul className="space-y-3" data-id="element-58">
              {forYou.map((item, index) => <li key={index} className="flex items-start gap-3" data-id="element-59">
                  <CheckCircleIcon className="w-5 h-5 text-[#22C55E] flex-shrink-0 mt-0.5" data-id="element-60" />
                  <span className="text-[#4A4A5A]" data-id="element-61">{item}</span>
                </li>)}
            </ul>
          </div>

          <div className="bg-white p-5 rounded-xl border-t-4 border-[#EF4444]" data-id="element-62">
            <h3 className="text-xl font-bold text-[#1A1A2E] mb-4 text-center" data-id="element-63">
              ESTO NO ES PARA TI SI:
            </h3>
            <ul className="space-y-3" data-id="element-64">
              {notForYou.map((item, index) => <li key={index} className="flex items-start gap-3" data-id="element-65">
                  <XCircleIcon className="w-5 h-5 text-[#EF4444] flex-shrink-0 mt-0.5" data-id="element-66" />
                  <span className="text-[#4A4A5A]" data-id="element-67">{item}</span>
                </li>)}
            </ul>
          </div>
        </div>
      </div>
    </section>;
}